import React, { useEffect, useContext } from 'react'

import { UserContext } from '../contexts/UserContext'
import LoadingLogo from './general/LoadingLogo'

export const Logout = () => {
  const { logoutHandler } = useContext(UserContext)

  useEffect(() => {
    logoutHandler()
  }, [logoutHandler])

  return (
    <div style={{ height: '100%', display: 'grid', placeItems: 'center' }}>
      <LoadingLogo />
    </div>
  )
}
